// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
require("../../stubs/hcuSearchResults/hcuSearchResults.less");

import run from "../../../utilities/run";
import {bindHardSubmit} from "../../../utilities/submitHelpers";
const commerceSearchSelector = "#p_p_id_searchportlet_WAR_commerceuportlet_";

run(commerceSearchSelector, ()=>{
  attachSearch();
});

function attachSearch(){
  bindHardSubmit({
    form: $('.commerce-u-search-form'),  
    links: $('.commerce-u-search')
  });
} 


// WEBPACK FOOTER //
// ./src/pages/hcu/hcuSearch/hcuSearch.js